import BaseModel from "../default/base-model";
import {Component} from "./component";
import {Po} from "./po";

export class PoComponent extends BaseModel {
    po?: Po;
    component?: Component;
    estimated_time_delivery?: Date;
    quantity?: number;
    converted_quantity?: number;
    unit?: string;
    purchase_order_number?: string;
    matl_type?: string;
    part_number?: string;
    description?: string | null;
    invoice?: string | null;
    status?: PoStatus;
    sap_flags?: FlagsSap;
}

export enum PoStatus {
    PLANNING = "PLANNING",
    IN_TRANSIT = "IN_TRANSIT",
}

export enum FlagsSap {
    OK = "0",
    PAST_DATE_ERROR = "1",
}
